import { gql } from 'graphql-request'

export const Q_VALIDATE_COUPON = gql`
  query ValidateCoupon($code: String!) {
    validateCoupon(code: $code) {
      ... on ValidateCouponResult {
        valid
        couponId
        name
        percentOff
        amountOff
        duration
        durationInMonths
      }

      ... on QueryFailure {
        errors {
          message
        }
      }
    }
  }
`
